module.exports = __webpack_public_path__ + "@/assets/img/pp_finished.6a02b0dc.svg";